import React from 'react';
import './CreateOptions.css';
import { useNavigate } from 'react-router-dom'

const CreateOptions = () => {
  const navigate = useNavigate();
  const options = [
    {
      title: "Create a book",
      description: "Create a book with just a short title and description",
      image: "/create-book/write.png",
      buttonText: "Create a book",
      link: "/create/1-write"
    },
    {
      title: "Create a book from template",
      description: "Create a book based on selection of predefined templates",
      image: "/create-book/template.png",
      buttonText: "Create a book from one of our templates",
      onClick: () => navigate('/create/1-write')
    },
    {
      title: "Illustrator",
      description: "Illustrate your own story",
      image: "/create-book/illustrator.png",
      buttonText: "Illustrate your own story",
      link: "/create/illustrator",
      disabled: true
    }
  ];

  return (
    <div className="create-book">
      <div className="create-book-content">
        <h1>Create your first children's book</h1>
        <p className="subtitle">Pick one of the features below to create your first children's book</p>
        
        <div className="options-grid">
          {options?.map((option, index) => (
            <div 
                key={index} 
                className={`option-card ${option.disabled ? 'disabled' : ''}`}
                onClick={() => !option.disabled && option.onClick?.()}
            >
              <h2>{option.title}</h2>
              <p>{option.description}</p>
              <img src={option.image} alt={option.title} />
              <a 
                href={option.link} 
                className={`option-button ${option.disabled ? 'disabled' : ''}`}
                onClick={(e) => option.disabled && e.preventDefault()}
              >
                {option.buttonText}
              </a>
              {option.disabled && <div className="subscribers-only">Only for subscribers</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CreateOptions;